import React from "react";

const B2BenefitsHead = () => {
  return (
    <div className="lvlBenefitsHead">
      <h2>
        Benefits of B2 Level German Course at <span>Prizma Academy</span>
      </h2>
      <p>
        Elevate your German skills to an upper-intermediate level with our
        comprehensive B2 Level German Course. Here's what you'll gain:
      </p>
    </div>
  );
};

export default B2BenefitsHead;
